import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FaviconService {
    private document = inject<Document>(DOCUMENT);


    setFaviconImage(faviconImageUrl: string) {
        const link: HTMLLinkElement = this.document.createElement('link');
        link.setAttribute('rel', 'icon');
        link.setAttribute('type', 'image/x-icon');
        link.setAttribute('href', faviconImageUrl);
        this.document.head.appendChild(link);
    }
}
